/**
 * Shop panel of the Ava & Bear mega menu: hovering or focusing a category on the left
 * shows that category's product carousel; the arrow buttons scroll the carousel.
 */
class AbMegaShop extends HTMLElement {
  connectedCallback() {
    this.addEventListener('pointerover', this.#onIntent);
    this.addEventListener('focusin', this.#onIntent);
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.#onIntent);
    this.removeEventListener('focusin', this.#onIntent);
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {Event} event */
  #onIntent = (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-ab-group]');
    if (!(link instanceof HTMLElement) || link.classList.contains('is-active')) return;
    this.#show(link);
  };

  /** @param {HTMLElement} link */
  #show(link) {
    const groupId = link.dataset.abGroup;
    for (const other of this.querySelectorAll('[data-ab-group]')) {
      other.classList.toggle('is-active', other === link);
    }
    for (const group of this.querySelectorAll('.ab-mega__group')) {
      const active = group.id === groupId;
      group.toggleAttribute('hidden', !active);
      group.classList.toggle('is-active', active);
      if (active) group.querySelector('.ab-mega__track')?.scrollTo({ left: 0 });
    }
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const arrow = event.target.closest('[data-ab-scroll]');
    if (!(arrow instanceof HTMLElement)) return;
    const track = arrow.closest('.ab-mega__group')?.querySelector('.ab-mega__track');
    if (!track) return;
    const direction = Number(arrow.dataset.abScroll) || 1;
    track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
  };
}

if (!customElements.get('ab-mega-shop')) {
  customElements.define('ab-mega-shop', AbMegaShop);
}
